import { CommonTexts } from './CommonTexts';
import type { SearchBody } from '../api/types/api.types';

/** What the list search and the big search show alike. */
class SearchServiceClass {
    /** How long a field of the big search has to rest before it starts. */
    public readonly DelayMs = 2000;

    /** What was really searched: alphabetically, a tag by its name; the API sends every term in small letters. */
    public getTermsText(search: SearchBody | null): string {
        if (search === null) {
            return '';
        }

        return [...search.words, ...search.tags.map((tag: string): string => `#${tag}`)].sort(this.compareTerms.bind(this)).join(' ');
    }

    /** Names only what the row itself does not show; without such a hit there is nothing to explain. */
    public getFoundInText(fields: string[]): string | undefined {
        return fields.length === 0 ? undefined : CommonTexts.format(CommonTexts.SearchFoundIn, { fields: fields.join(', ') });
    }

    private compareTerms(first: string, second: string): number {
        return first.replace('#', '').localeCompare(second.replace('#', ''), 'de');
    }
}

export const SearchService = new SearchServiceClass();
